import { render, staticRenderFns } from "./ScrollbBoard.vue?vue&type=template&id=d30b5860&scoped=true&"
import script from "./ScrollbBoard.vue?vue&type=script&lang=js&"
export * from "./ScrollbBoard.vue?vue&type=script&lang=js&"
import style0 from "./ScrollbBoard.vue?vue&type=style&index=0&id=d30b5860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30b5860",
  null
  
)

export default component.exports